import clsx from 'clsx'

import { Icon, type IconProps } from '../../src'
import styles from './styles.module.css'

export function CollapsibleCardIcon(props: IconProps) {
  const classes = clsx(styles.icon, props.className)

  return <Icon size='md' {...props} className={classes} />
}

CollapsibleCardIcon.displayName = 'CollapsibleCard.Icon'
